import React from "react";
import { useI18n } from "../context/I18nContext";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

export function LanguageSwitcher({ compact = false, light = false }) {
  const { lang, setLang, langs } = useI18n();
  const current = langs.find((l) => l.code === lang);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" data-testid="language-switcher-btn"
          className={`gap-1.5 rounded-full transition-colors ${light ? "text-white hover:bg-white/10 hover:text-white" : "text-navy hover:bg-mustard/15"}`}>
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{current?.flag} {compact ? current?.code.toUpperCase() : current?.label}</span>
          <span className="sm:hidden">{current?.flag}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-xl">
        {langs.map((l) => (
          <DropdownMenuItem key={l.code} data-testid={`lang-option-${l.code}`}
            onClick={() => setLang(l.code)} className="gap-2 cursor-pointer">
            <span>{l.flag}</span><span className="flex-1">{l.label}</span>
            {lang === l.code && <Check className="h-4 w-4 text-coral" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
